import React, { useState } from 'react';
import Img from 'gatsby-image';

import { DialogContent, DialogOverlay } from '@reach/dialog';
import '@reach/dialog/styles.css';
import { useTransition, animated } from 'react-spring';

import { ZoomInIcon } from '../icons';

import './lightbox.css';

export default ({ allowPinchZoom, gif, image, icon, aspect }) => {
    const AnimatedDialogOverlay = animated(DialogOverlay);
    const AnimatedDialogContent = animated(DialogContent);

    const [showLightbox, setShowLightbox] = useState(false);
    const closeLightbox = () => setShowLightbox(false);
    // Only open the lightbox on larger screens. On smaller resolutions,
    // the page layout already has the image as big as the lightbox.
    const openLightbox = () =>
        window.innerWidth > 960 ? setShowLightbox(true) : null;

    const transitions = useTransition(showLightbox, null, {
        from: { opacity: 0, y: -10 },
        enter: { opacity: 1, y: 0 },
        leave: { opacity: 0, y: -20 },
    });

    return (
        <>
            {/* Display the image or gif */}
            <button
                className={
                    aspect ? 'lightbox-click ' + aspect : 'lightbox-click'
                }
                onClick={openLightbox}
            >
                {image ? <Img alt="" fluid={image} /> : null}
                {gif ? <img alt="" src={gif}></img> : null}
                {icon ? icon : null}
                <div className="expand-tooltip">
                    expand <ZoomInIcon />
                </div>
            </button>

            {/* Animated Lightbox */}
            {transitions.map(
                ({ item, key, props: styles }) =>
                    item && (
                        <AnimatedDialogOverlay
                            allowPinchZoom={allowPinchZoom}
                            isOpen={showLightbox}
                            key={key}
                            onDismiss={closeLightbox}
                            style={{ opacity: styles.opacity }}
                        >
                            {' '}
                            <AnimatedDialogContent
                                aria-label="Enlarged image"
                                className="lightbox"
                                style={{
                                    transform: styles.y.interpolate(
                                        value =>
                                            `translate3d(0px, ${value}px, 0px)`
                                    ),
                                    borderRadius: 10,
                                }}
                            >
                                <button
                                    className="close-button"
                                    onClick={closeLightbox}
                                >
                                    Close
                                </button>
                                {image && <Img alt="" fluid={image} />}
                                {gif && <img alt="" src={gif}></img>}
                            </AnimatedDialogContent>{' '}
                        </AnimatedDialogOverlay>
                    )
            )}
        </>
    );
};
